import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { AuthModal } from "@/components/AuthModal";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Account from "@/pages/Account";
import GiftCorporate from "@/pages/GiftCorporate";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import Customisation from "@/pages/Customisation";
import Catalogue from "@/pages/Catalogue";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, Terms, RefundCancellation, ShippingDelivery } from "@/pages/Policies";
import GiftingGuide from "@/pages/GiftingGuide";
import AuthCallback from "@/pages/AuthCallback";

const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Layout = ({ children, hideChrome }) => (
  <div className="App grain min-h-screen flex flex-col">
    {!hideChrome && <Navbar />}
    <main className="flex-1 relative z-10">{children}</main>
    {!hideChrome && <Footer />}
    {!hideChrome && <WhatsAppFloat />}
    <AuthModal />
  </div>
);

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <ScrollTop />
        <Toaster position="top-center" theme="dark" richColors />
        <AppRoutes />
      </BrowserRouter>
    </StoreProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/shop" element={<Layout><Shop /></Layout>} />
          <Route path="/product/:slug" element={<Layout><ProductDetail /></Layout>} />
          <Route path="/cart" element={<Layout><Cart /></Layout>} />
          <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
          <Route path="/order/:orderId" element={<Layout><OrderConfirmation /></Layout>} />
          <Route path="/account" element={<Layout><Account /></Layout>} />
          <Route path="/gifting" element={<Layout><GiftCorporate /></Layout>} />
          <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/terms-and-conditions" element={<Layout><Terms /></Layout>} />
          <Route path="/refund-cancellation" element={<Layout><RefundCancellation /></Layout>} />
          <Route path="/shipping-delivery" element={<Layout><ShippingDelivery /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/catalogue" element={<Layout><Catalogue /></Layout>} />
          <Route path="/gifting-guide" element={<Layout><GiftingGuide /></Layout>} />
          <Route path="/customisation" element={<Layout><Customisation /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
          <Route path="/admin" element={<Layout hideChrome><Admin /></Layout>} />
        </Routes>
  );
}

export default App;
